import { FiPaperclip, FiLock, FiX } from "react-icons/fi";

/* ================= STATUS WORKFLOW ================= */

const statusFlow = {
  "Not Started": "In Progress",
  "In Progress": "Submitted",
  "Submitted": "Reviewed",
  "Reviewed": "Approved",
  "Approved": null
};

const ChecklistExecutionDrawer = ({
  drawerItem,
  setDrawerItem,
  updateChecklist,
  handleSave,
  handleAttachment
}) => {

  if (!drawerItem) return null;

  /* ================= STATUS MOVE ================= */

  const handleNextStatus = () => {

    const next = statusFlow[drawerItem.Status];
    if (!next) return;

    updateChecklist(
      drawerItem.ChecklistItemID,
      "Status",
      next
    );
  };



  /* ================= UI ================= */

  return (
    <div className="fixed inset-0 z-50">

      {/* Overlay */}
      <div
        onClick={() => setDrawerItem(null)}
        className="absolute inset-0 bg-black opacity-30"
      />

      {/* Drawer */}
      <div className="
        absolute top-0 right-0 h-full w-[520px]
        bg-white shadow-2xl rounded-l-2xl
        flex flex-col
      ">

        {/* ================= HEADER ================= */}
        <div className="px-8 pt-8 pb-6 border-b flex justify-between">

          <div>
            <h3 className="text-xl font-semibold">
              {drawerItem.Title}
            </h3>

            <p className="text-xs text-slate-500 mt-1">
              Checklist Review & Documentation
            </p>
          </div>

          <button onClick={() => setDrawerItem(null)}>
            <FiX size={20} />
          </button>
        </div>

        {/* ================= BODY ================= */}
        <div className="flex-1 overflow-y-auto px-8 py-8 space-y-8">

          {/* STATUS */}
          <div>
            <label className="text-xs font-semibold text-slate-500">
              Status
            </label>

            <div className="flex items-center gap-3 mt-2">
              <span className="font-medium">
                {drawerItem.Status}
              </span>

              {statusFlow[drawerItem.Status] && (
                <button
                  onClick={handleNextStatus}
                  className="bg-indigo-600 text-white px-3 py-1 rounded text-xs"
                >
                  Move to {statusFlow[drawerItem.Status]}
                </button>
              )}
            </div>
          </div>

          {/* RESULT */}
          <div>
            <label className="text-xs font-semibold text-slate-500">
              Result
            </label>

           <select
  value={drawerItem?.Result || "In Order"}
  onChange={(e) =>
    updateChecklist(
      drawerItem.ChecklistItemID,
      "Result",
      e.target.value
    )
  }
  className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
>
  <option value="In Order">In Order</option>
  <option value="Observation">Observation</option>
</select>
          </div>

          {/* OBSERVATION */}
          {drawerItem.Result === "Observation" && (
            <div className="bg-red-50 border border-red-200 p-5 rounded-xl">

              <label className="text-xs font-semibold text-red-600">
                Observation Comment
              </label>

              <textarea
                rows={5}
                value={drawerItem.Observation || ""}
                onChange={(e) =>
                  updateChecklist(
                    drawerItem.ChecklistItemID,
                    "Observation",
                    e.target.value
                  )
                }
                placeholder="Describe issue, impact and recommendation..."
                className="w-full border border-red-300 rounded-lg p-2 mt-2"
              />

              <p className="text-xs text-red-500 mt-2">
                This item will appear in Observation Summary.
              </p>
            </div>
          )}

          {/* ATTACHMENTS */}
          <div>
            <label className="text-xs font-semibold text-slate-500">
              Attachments
            </label>

            <label className="
              flex flex-col items-center justify-center
              border-2 border-dashed rounded-xl py-6 mt-3
              cursor-pointer hover:bg-indigo-50
            ">
              <FiPaperclip size={18}/>
              Upload Supporting Documents

              <input
  type="file"
  className="hidden"
  onChange={(e) =>
    handleAttachment(
      drawerItem.ChecklistItemID,
      e.target.files[0]
    )
  }
/>
{drawerItem.Attachments?.length > 0 && (
  <div className="mt-4 space-y-2 text-xs text-slate-600">
    {drawerItem.Attachments.map((file, i) => (
      <div
        key={i}
        className="flex justify-between bg-slate-50 px-3 py-2 rounded-md"
      >
        <span>{file}</span>
        <span className="text-slate-400">Uploaded</span>
      </div>
    ))}
  </div>
)}

            </label>
          </div>

          {/* AUDIT TRAIL */}
          <div className="bg-slate-50 border rounded-xl p-5 text-xs space-y-2">
            <div className="font-semibold text-slate-500">
              Audit Trail
            </div>

            <div>Prepared By: {drawerItem.SubmittedBy || "-"}</div>
            <div>Reviewed By: {drawerItem.ReviewedBy || "-"}</div>
          </div>

        </div>

        {/* ================= FOOTER ================= */}
        <div className="border-t p-6">
          <button
            onClick={() => {
              handleSave(drawerItem);
              setDrawerItem(null);
            }}
            className="w-full bg-indigo-600 text-white py-3 rounded-lg"
          >
            Save Changes
          </button>
        </div>

      </div>
    </div>
  );
};

export default ChecklistExecutionDrawer;